module.exports = __webpack_public_path__ + "img/gridModeOff.a7eba0e6.svg";